import { motion } from "framer-motion";
import { Play, Sparkles } from "lucide-react";
import VoiceButton from "./VoiceButton";

export const PepeSection = () => (
  <section id="pepe" className="relative py-24 sm:py-32 scroll-mt-20">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-viol/30 bg-viol/10 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-viol-pale">
            <Sparkles size={13} />
            Démo maison — créée en interne
          </span>
          <h2 className="mt-6 font-display font-bold text-3xl sm:text-5xl text-white leading-tight">
            Pepe, influenceur IA.
          </h2>
          <p className="mt-5 text-mist leading-relaxed">
            Un Sicilien de 70 ans, entièrement créé par nos soins : visage,
            voix, caractère, contenu. Pepe n'existe pas — et pourtant il
            publie, il parle, il fait rire.
          </p>
          <p className="mt-4 text-mist leading-relaxed">
            C'est la preuve que GiulIATeck sait construire un personnage IA de
            A à Z. Exactement ce que Giulia fait pour votre marque.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <div
            className="group relative aspect-video overflow-hidden rounded-2xl border border-ink-line bg-gradient-to-br from-ink-surface via-ink-soft to-ink-surface noise"
            data-testid="pepe-video-placeholder"
          >
            <div
              aria-hidden="true"
              className="absolute inset-0 opacity-40"
              style={{
                backgroundImage:
                  "linear-gradient(rgba(139,92,246,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.08) 1px, transparent 1px)",
                backgroundSize: "36px 36px",
              }}
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 h-16 bg-gradient-to-b from-transparent via-viol/15 to-transparent animate-scanline"
            />
            <div className="absolute top-4 left-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-mist/80">
              <span className="h-2 w-2 rounded-full bg-red-500/80 animate-pulse" />
              Rec — Pepe_AI
            </div>
            <span className="absolute top-4 right-4 font-mono text-[10px] tracking-[0.2em] text-mist/60">1080p · 9:16 ready</span>

            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <span className="absolute inset-0 rounded-full bg-viol/30 blur-xl animate-pulseGlow" />
                <span className="relative flex h-16 w-16 items-center justify-center rounded-full glass text-white transition-transform duration-300 group-hover:scale-110">
                  <Play size={24} className="translate-x-0.5" fill="currentColor" />
                </span>
              </div>
            </div>

            <div className="absolute bottom-0 inset-x-0 p-4 flex items-end justify-between">
              <p className="font-mono text-[11px] text-mist/80">Vidéo de démonstration — à venir</p>
              <div className="flex items-end gap-1 h-5" aria-hidden="true">
                {[0.7, 1, 0.5, 0.9, 0.6, 1, 0.75].map((h, i) => (
                  <span
                    key={i}
                    className="w-1 rounded-full bg-viol/70 origin-bottom animate-wave"
                    style={{ height: `${h * 100}%`, animationDelay: `${i * 0.12}s` }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-3 flex flex-col items-center gap-2.5">
            <VoiceButton
              voice="pepe"
              text="Eh, bonjour ! Moi c'est Pepe. Soixante-dix ans, Sicilien, et pourtant je suis né dans un ordinateur. GiulIATeck m'a fabriqué de zéro : la figure, la voix, le caractère. Si on peut créer un personnage comme moi, imagine ce que Giulia peut faire pour ta marque."
              label="Écouter Pepe se présenter"
              testId="pepe-voice-btn"
            />
            <p className="text-center font-mono text-[11px] uppercase tracking-[0.25em] text-mist/60">
              Placeholder élégant — la vraie vidéo de Pepe arrive
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default PepeSection;
